"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseSubdomain = void 0;

var _urlJoin = require("./url-join");

/* eslint-disable import/prefer-default-export, no-plusplus */
// parseUrl with subdomain
var parseSubdomain = function parseSubdomain() {
  var subdomain = arguments.length <= 0 ? undefined : arguments[0];
  var host = arguments.length <= 1 ? undefined : arguments[1];
  var url = host;

  if (subdomain && subdomain !== "www" && subdomain !== "rentspree") {
    url = host.replace("www", subdomain);
  }

  for (var i = 2; i < arguments.length; i++) {
    url = (0, _urlJoin.urlJoin)(url, i < 0 || arguments.length <= i ? undefined : arguments[i]);
  }

  return url;
};

exports.parseSubdomain = parseSubdomain;